// breeds-directory.js
(function () {
  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qAll(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  document.addEventListener('DOMContentLoaded', function () {
    const grid = q('#bd-grid');
    if (!grid) return;

    const cards = qAll('.breed-card', grid);
    const search = q('#bd-search');
    const clearBtn = q('#bd-clear');
    const alphabet = q('#bd-alphabet');
    const alphaBtns = qAll('.bd-alpha-btn', alphabet);
    const groupChecks = qAll('.bd-filter-checkbox[data-filter="group"]');
    const sizeChecks = qAll('.bd-filter-checkbox[data-filter="size"]');
    const emptyEl = q('#bd-empty');

    function norm(s) { return (s || '').toString().trim().toLowerCase(); }

    function getActive() {
      const qv = norm(search && search.value);
      const letterEl = alphabet.querySelector('.bd-alpha-btn.active');
      const letter = letterEl ? letterEl.dataset.letter : 'ALL';
      const groups = groupChecks.filter(c => c.checked).map(c => norm(c.value));
      const sizes = sizeChecks.filter(c => c.checked).map(c => norm(c.value));
      return { qv, letter, groups, sizes };
    }

    function matches(card, filters) {
      const name = norm(card.dataset.name);
      const group = norm(card.dataset.group);
      const size = norm(card.dataset.size);
      const traits = norm(card.dataset.traits);
      const origin = norm(card.dataset.origin);

      // Search in name / traits / origin
      if (filters.qv) {
        const q = filters.qv;
        const inName = name.indexOf(q) !== -1;
        const inTraits = traits.indexOf(q) !== -1;
        const inOrigin = origin.indexOf(q) !== -1;
        if (!(inName || inTraits || inOrigin)) return false;
      }

      // Alphabet
      if (filters.letter && filters.letter !== 'ALL') {
        if (!name.startsWith(filters.letter.toLowerCase())) return false;
      }

      // Group
      if (filters.groups.length && filters.groups.indexOf(group) === -1) return false;

      // Size
      if (filters.sizes.length && filters.sizes.indexOf(size) === -1) return false;

      return true;
    }

    function render() {
      const f = getActive();
      let visible = 0;
      cards.forEach(c => {
        if (matches(c, f)) {
          c.style.display = '';
          visible++;
        } else {
          c.style.display = 'none';
        }
      });
      if (emptyEl) emptyEl.style.display = visible ? 'none' : '';
    }

    // debounce for search
    function debounce(fn, ms) {
      let t;
      return function () {
        clearTimeout(t);
        const args = arguments;
        t = setTimeout(function () { fn.apply(null, args); }, ms);
      };
    }

    if (search) {
      search.addEventListener('input', debounce(render, 180));
      clearBtn.addEventListener('click', function () {
        search.value = '';
        render();
        search.focus();
      });
    }

    alphaBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        alphaBtns.forEach(b => b.classList.remove('active'));
        this.classList.add('active');
        render();
      });
    });

    groupChecks.forEach(cb => cb.addEventListener('change', render));
    sizeChecks.forEach(cb => cb.addEventListener('change', render));

    // initial render
    render();
  });
})();